import { jsx } from "react/jsx-runtime";
import { AccessorTreeStateContext } from "./AccessorTreeStateContext.js";
import { DirtinessContext } from "./DirtinessContext.js";
import { MutationStateContext } from "./MutationStateContext.js";
import { EnvironmentContext } from "../accessorPropagation/EnvironmentContext.js";
import { BindingOperationsProvider } from "../accessorPropagation/BindingOperationsProvider.js";
const AccessorTree = ({ state, children }) => {
  const stateData = state.name === "initialized" ? state.data : {
    hasUnpersistedChanges: false,
    isMutating: false,
    bindingOperations: void 0
  };
  return /* @__PURE__ */ jsx(EnvironmentContext.Provider, { value: state.environment, children: /* @__PURE__ */ jsx(AccessorTreeStateContext.Provider, { value: state, children: /* @__PURE__ */ jsx(DirtinessContext.Provider, { value: stateData.hasUnpersistedChanges, children: /* @__PURE__ */ jsx(MutationStateContext.Provider, { value: stateData.isMutating, children: /* @__PURE__ */ jsx(BindingOperationsProvider, { bindingOperations: stateData.bindingOperations, children }) }) }) }) });
};
AccessorTree.displayName = "AccessorTree";
export {
  AccessorTree
};
//# sourceMappingURL=AccessorTree.js.map
